import { render, staticRenderFns } from "./AnswerSheetItemComponent.vue?vue&type=template&id=38d9799b&scoped=true&"
import script from "./AnswerSheetItemComponent.vue?vue&type=script&lang=js&"
export * from "./AnswerSheetItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSheetItemComponent.vue?vue&type=style&index=0&id=38d9799b&prod&scoped=true&lang=scss&"
import style1 from "./AnswerSheetItemComponent.vue?vue&type=style&index=1&id=38d9799b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9799b",
  null
  
)

export default component.exports